export interface Props {
    message?: string
}

export const InputError = ({ message }: Props) => {
    if (!message) return null
    return <p className="text-destructive text-sm mt-1">{message}</p>
}
